<template>
  <FormItemWrapper class="summer">
    <FormItemLabel slot="label">
      {{ $t('formItemLabelLowTariff') }}
    </FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipLowTariff')"
      slot="tooltip"
      :content="$t('formItemTooltipLowTariff')"
    />
    <el-input
      v-model="activeLT"
      type="number"
      class="summer"
      placeholder=""
    >
      <template slot="append">kWh</template>
    </el-input>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { onKeydownAllowNumbersOnly } from '@/utils/validation';
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import { Input } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Input);

export default {
  name: 'CalculationActiveLT',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    ...mapGetters('filter', [
      'singleRate',
    ]),
    activeLT: {
      get() {
        return this.$store.state.calculation.activeCalculationData.activeLT;
      },
      set(value) {
        this.update(value);
      },
    },
  },
  watch: {
    singleRate: {
      handler(value) {
        if (value) this.update(0);
      },
      immediate: true,
    },
  },
  methods: {
    update: debounce(function update(value) {
      this.$store.commit('calculation/SET_ACTIVE_LT', Number(value));
    }, 500),
    onKeydownAllowNumbersOnly,
  },
};
</script>
